module.exports = __webpack_public_path__ + "static/media/dish3.37f6ad9b.jpg";